// Lëtzebuergescht Fragment vum Lot „Regelen“: Spillregelen (/regles-de-jeu, Zil
// vum QR-Code op der Schachtel), Bestellung gelongen (/success) an d’404-Säit.
// KOHÄRENZ: d’Froen 5, 7 an 11 ginn identesch an lb/experience.js nach eng
// Kéier benotzt (demo.question.*) — all Ännerung hei muss do matgemaach ginn.
// D’Schätzfro vun der Demo (demo.subsidiaire.question) ass EXPRES eng aner:
// d’Haaptsäit verréit déi richteg ni.
// NOZEKUCKEN mam Dréckerei: falls e lëtzebuergesche Guide an der Schachtel
// matgeliwwert gëtt, mussen dës 11 Froe säin exakte Wuertlaut iwwerhuelen.
// NB: d’Äntwert op d’Schätzfro huet mat Wëllen KEE Schlëssel: si dierf nëmmen
// am GameRules.jsx stoen, hannert dem Klick „nëmme fir d’Elteren“.
export default {
  // --- Spillregelen: SEO ---
  'regles.seo.titre': 'Spillregele vu Joyful Reveal',
  'regles.seo.description':
    'Déi komplett Spillregele vum Gender-Reveal-Spill Joyful Reveal: bildt zwou Equipen, äntwert op déi 11 Froen, leet de Puzzle zesummen a rubbelt dat lescht Stéck op, dat d’Geschlecht vum Bëbee verréit.',

  // --- Spillregelen: Kappzeil ---
  'regles.entete.titre': 'D’Spillregelen',
  'regles.entete.introAvant':
    'Zwou Equipen, 11 Froen, e Puzzle fir zesummenzeleeën an e lescht Stéck fir ze rubbelen. Rechent mat ronn',
  'regles.entete.introDuree': '20 Minutten',
  'regles.entete.introEntre': ', fir',
  'regles.entete.introJoueurs': '2 bis 10 Spiller',

  // --- Spillregelen: Warnung fir d’Gäscht ---
  'regles.invite.titre': '🤫 Sidd Dir op eng Feier invitéiert?',
  'regles.invite.destinee': 'Dës Säit ass fir',
  'regles.invite.parents': 'zukünfteg Elteren',
  'regles.invite.suite':
    'geduecht, déi d’Spill virbereeden. Wann Dir Spiller sidd, maacht se nees zou: Dir géift Iech Är eege Iwwerraschung verdierwen!',

  // --- Spillregelen: Inhalt vum Kit ---
  'regles.kit.titre': '🎁 Wat an Ärem Kit dran ass',
  'regles.kit.sachetAvant': 'En Haaptsäckelche mat',
  'regles.kit.sachetPieces': '11 Puzzlestécker',
  'regles.kit.grattoirAvant': 'an',
  'regles.kit.grattoirPiece': 'engem eenzegaartege Rubbelstéck',
  'regles.kit.grattoirFin': '— dat Stéck, dat alles verréit.',
  'regles.kit.premium':
    'De Pack Premium bréngt nach déi zwee Stoffsäckelcher vun den Equipen derbäi, de Froebou gedréckt op Kartong vu 400 g an d’Souvenir-Enveloppe, déi no der Feier hannen op e Bilderkader kënnt.',

  // --- Spillregelen: déi 4 Etappen ---
  'regles.etape1.titre': 'Ier d’Gäscht ukommen',
  'regles.etape1.alt':
    'Den Inhalt vum Spill Joyful Reveal ausgebreet: d’Schachtel, de Froebou an déi zwee Stoffsäckelcher',
  'regles.etape1.p1':
    'Déi zukünfteg Eltere wielen déi 11 Froen aus, op déi d’Spiller äntwere mussen. Bei all richteger Äntwert gëtt e Puzzlestéck gewonnen.',
  'regles.etape1.p2':
    'D’Äntwert ass ëmmer „Mamma“ oder „Papa“ — an natierlech ass alles mat engem Zwinkeren ze verstoen!',
  'regles.etape1.p3':
    'Dir kënnt eis fäerdeg Lëscht benotzen (méi wäit ënnen) oder Är eege Froe mam Blanko-Modell erfannen.',

  'regles.etape2.titre': 'Bildt déi zwou Equipen',
  'regles.etape2.alt': 'Déi zwee Stoffsäckelcher vum Spill, mat den Etiquetten Equipe 1 an Equipe 2',
  'regles.etape2.p1': 'Deelt Är Gäscht op zwou Equipen op — zum Beispill:',
  'regles.etape2.equipe1Label': 'Equipe 1',
  'regles.etape2.equipe1Texte': 'déi, déi mengen, datt de Bëbee e Meedche gëtt 💗',
  'regles.etape2.equipe2Label': 'Equipe 2',
  'regles.etape2.equipe2Texte': 'déi, déi mengen, datt de Bëbee e Jong gëtt 💙',

  'regles.etape3.titre': 'D’Spill: déi 11 Stécker gewannen',
  'regles.etape3.alt':
    'Récksäit vun der Joyful-Reveal-Schachtel mat engem Iwwerbléck vun deenen 4 Etappe vum Spill',
  'regles.etape3.p1':
    'Déi zukünfteg Eltere stelle d’Froen eng no der anerer. Déi Equipe, déi als éischt déi richteg Äntwert gëtt, gewënnt e Puzzlestéck.',
  'regles.etape3.p2': 'Sou geet et weider fir all 11 klassesch Stécker.',
  'regles.etape3.p3':
    'Wa mol déi 11 Stécker gewonne sinn, schaffen déi zwou Equipen zesummen, fir de Puzzle ze leeën… an dann feelt nach just een eenzegt Stéck!',

  'regles.etape4.titre': 'Dat lescht Stéck: déi grouss Uskënnegung',
  'regles.etape4.alt': 'D’Schachtel vum Spill Joyful Reveal mam Puzzlestéck fir ze rubbelen',
  'regles.etape4.p1':
    'Nëmmen d’Equipe, déi déi meeschte Stécker gewonnen huet, dierf dës lescht Ronn spillen — an dës Kéier spillt all Spiller fir sech eleng.',
  'regles.etape4.p2':
    'Déi zukünfteg Eltere stellen elo d’Schätzfro. De Spiller, deem seng Schätzung am nooste beim Resultat läit, gewënnt dat lescht Stéck… an d’Privileg, et opzerubbelen!',

  // --- Spillregelen: Schätzfro (d’Äntwert bleift am JSX) ---
  'regles.subsidiaire.surtitre': 'D’Schätzfro',
  'regles.subsidiaire.question':
    '„Wéi vill Wegwerfwëndele benotze jonk Elteren am Duerchschnëtt am éischte Liewensjoer vum Bëbee?“',
  'regles.subsidiaire.reponseLabel': 'Äntwert:',
  'regles.subsidiaire.bouton': '👀 Äntwert weisen (nëmme fir d’Elteren)',
  'regles.subsidiaire.libre':
    'Et ass eis Lieblingsfro — mee wielt gär Är eegen: d’Äntwert muss just eng Zuel sinn, déi ee schätze kann.',

  // --- Spillregelen: de Conseil ---
  'regles.conseil.surtitre': '💡 E klengen Tipp',
  'regles.conseil.titre': 'Widderstitt der Versuchung, Är Gäscht virzewarnen!',
  'regles.conseil.texte':
    'Stellt Iech emol hir Reaktioun vir, wa se d’Spill entdecken a mierken, datt si e ganz besonnesche Moment voller Spannung erliewe wäerten. Et lount sech wierklech, hir Gesiichter oplieche ze gesinn. Also haalt duerch a verrot Äert Geheimnis net!',

  // --- Spillregelen: déi 11 Froen ---
  'regles.questions.titre': '📝 Déi 11 Froen, prett fir ze spillen',
  'regles.questions.imprimer': '🖨️ Drécken',
  'regles.questions.q1': 'Wien ass de beschte Kach, fir dem Bëbee säi Bräi ze maachen?',
  'regles.questions.q2': 'Wie kritt am séiersten Panik bei der Gebuert?',
  'regles.questions.q3':
    'Wie behält méi liicht d’Gebuertsgréisst an d’Gebuertsgewiicht vum Bëbee?',
  'regles.questions.q4':
    'Wien huet am meeschte Schwieregkeeten, dem Bëbee d’Wëndelen ze wiesselen?',
  'regles.questions.q5': 'Wie séngt d’Schlofliddercher op eng katastrophal Manéier?',
  'regles.questions.q6': 'Wie kann net widderstoen, séiss awer onnëtz Kleedercher ze kafen?',
  'regles.questions.q7': 'Wie kräischt bei Kannerfilmer?',
  'regles.questions.q8': 'Wie mécht déi bescht Grimasse, fir de Bëbee zum Laache ze bréngen?',
  'regles.questions.q9':
    'Wie kritt et am mannsten hin, dem Bëbee d’Kleeder unzedoen?',
  'regles.questions.q10': 'Wien ass de beschte Geschichtenerzieler, fir de Bëbee anzeschléferen?',
  'regles.questions.q11':
    'Wie géif de Bëbee ongeschéckt opwecken, well en op eng Spillsaach trëppelt, déi Kaméidi mécht?',
  'regles.questions.persoAvant':
    'Loscht op eppes Perséinleches? Ersetzt dës Froe roueg duerch Är eegen — d’Haaptsaach ass, datt et ëmmer nëmmen zwou méiglech Äntwerte ginn:',
  'regles.questions.persoMaman': '„Mamma“',
  'regles.questions.persoOu': 'oder',
  'regles.questions.persoPapa': '„Papa“',
  'regles.questions.persoFin': '. De Pack Premium enthält e Blanko-Modell, deen extra dofir geduecht ass.',

  // --- Spillregelen: leschte CTA ---
  'regles.cta.titre': 'Nach kee Spill doheem?',
  'regles.cta.texte': 'Vill Spaass — an nach eng Kéier villmools Gléckwonsch, zukünfteg Elteren! 🎉',
  'regles.cta.bouton': '🛒 D’Spill entdecken',

  // --- 404-Säit (NotFound.jsx), ënner „regles“ agerummt, well et kee eegene Beräich gëtt ---
  'regles.introuvable.seoTitre': '404 - Säit net fonnt',
  'regles.introuvable.seoDescription':
    'D’Säit, déi Dir sicht, gëtt et net. Gitt zréck op d’Startsäit oder entdeckt eise Shop.',
  'regles.introuvable.titre': '404 - Oups!',
  'regles.introuvable.sousTitre': 'D’Säit, déi Dir sicht, konnte mir net fannen.',
  'regles.introuvable.texte':
    'Vläicht gouf d’Säit geläscht oder verréckelt, oder d’URL stëmmt net.',
  'regles.introuvable.boutonAccueil': '🏠 Zréck op d’Startsäit',
  'regles.introuvable.boutonBoutique': '🛍️ An de Shop',
  'regles.introuvable.aide': 'Braucht Dir Hëllef?',
  'regles.introuvable.aideLien': 'Kontaktéiert eis',

  // --- Bestellung gelongen (Success.jsx) ---
  'succes.chargement.titre': 'Är Bestellung gëtt ofgeschloss...',
  'succes.chargement.texte':
    'Mir sichen Är Verfollegungsnummer eraus, dat dauert net laang.',
  'succes.entete.titre': 'Bestellung gelongen!',
  'succes.entete.numeroLabel': 'Bestellnummer:',
  'succes.entete.merci':
    'Merci fir Äre Kaf! Dir kritt eng Bestätegungsmail mat den Detailer vun Ärer Bestellung an Ärer Rechnung.',
  'succes.suivi.titre': 'Äre Pak verfollegen',
  'succes.suivi.etiquette': 'Är Versandetikett ass ugeluecht!',
  'succes.suivi.numeroLabel': 'Verfollegungsnummer:',
  'succes.suivi.bouton': '🚚 Mäi Pak verfollegen',
  'succes.suivi.astuce':
    '💡 Dir fannt dëse Link och an Ärem Profil → Meng Bestellungen',
  'succes.attente.texte':
    'Är Bestellung gëtt beaarbecht. D’Verfollegungsnummer erschéngt geschwënn an Ärem Clientsberäich.',
  // Spillguide fir erofzelueden. Doran steet d’Äntwert op d’Schätzfro: d’Warnung
  // ass keng Dekoratioun.
  // Affiché quand la session de paiement n'est plus lisible (lien rouvert
  // des semaines plus tard) : la page restait alors amputée EN SILENCE —
  // ni numéro de commande, ni guide, ni facture, et aucune explication.
  'succes.introuvable.texte':
    "Är Bezuelung ass gutt duerchgaang. Mir kënnen d'Detailer vun dëser Bestellung just hei net uweisen — dat geschitt, wann dëse Link méi spéit erëm opgemaach gëtt. Är Bestätegungsmail enthält Är Bestellnummer an Är Rechnung; schreift eis, wann Dir se net fannt.",
  'succes.guide.titre': 'Äre Spillguide',
  'succes.guide.texte':
    'Dat komplett Heftchen, mat den 11 Froen, prett fir ze spillen, an dem Blanko-Modell fir Är eege Froen. Haalt et um grousse Dag bei der Hand.',
  'succes.guide.bouton': '📥 De Guide eroflueden (PDF)',
  'succes.guide.avertissement':
    '⚠️ Nëmme fir déi zukünfteg Elteren: hie verréit d’Äntwert op d’Schätzfro.',

  'succes.questionnaire.titre': 'Äre Souvenir-Froebou',
  'succes.questionnaire.texte':
    'D’Quizfiche prett fir ze drécken, am selwechte Format wéi d’Kaart am Spill: déi 11 Froen an d’Equipe-Kolonnen. Kräizt d’Këscht u fir eng eidel Versioun, fir mat Ären eegene Froen auszefëllen.',
  'succes.questionnaire.vierge': 'Eidel Versioun (fir Är eege Froen ze schreiwen)',
  'succes.questionnaire.bouton': '📥 De Froebou eroflueden (PDF)',
  'succes.questionnaire.avertissement':
    '⚠️ Nëmme fir déi zukünfteg Elteren: op der Récksäit steet d’Äntwert op d’Schätzfro.',

  "succes.facture.titre": "Är Rechnung",
  "succes.facture.texte":
    "D’Rechnung vun Ärer Bestellung (op Franséisch) ass prett. Stripe schéckt Iech dozou nach eng Bezuelungsquittung per E-Mail.",
  "succes.facture.bouton": "🧾 Rechnung kucken an drécken",
  'succes.avis.titre': 'Är Meenung zielt!',
  'succes.avis.texte':
    'Deelt Är Erfarung an hëlleft anere Clienten, eis Produiten z’entdecken.',
  'succes.avis.bouton': '✍️ Eng Meenung hannerloossen',
  'succes.actions.commandes': '📋 Meng Bestellunge kucken',
  'succes.actions.boutique': '🎮 Weider akafen',
};
